import Vue from 'vue'
import Vuex from 'vuex'
import user from './moduels/user'
import route from './moduels/route'
import layout from './moduels/layout'
import order from './moduels/order'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 存在token
    Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : ''
  },
  mutations: {
    changeLogin() {

    }
  },
  actions: {
  },
  modules: {
    user,
    route,
    layout,
    order
  }
})
